<template>
  <div>
    <h2 class="mb-5">Listado de aprobaciones</h2>
    <Filters/>
    <ApprovalsTable :company="company"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Filters from '@/febos/chile/approvals/components/templates/Filters';
import ApprovalsTable from '@/febos/chile/approvals/components/templates/ApprovalsTable';

export default {
  name: 'ListTemplates',
  components: {
    Filters,
    ApprovalsTable
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
  },
  methods: {
    ...mapActions('Approvals', ['getReferenceApprovals']),
  },
  created() {
    this.getReferenceApprovals();
  }
};
</script>
<style scoped>

</style>
